import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { ButtonBase, Stack } from "@mui/material";

interface AddToCalendarCardProps {
  disabled?: boolean;
  onClick: () => void;
}

export function AddToCalendarCard(props: AddToCalendarCardProps) {
  const { disabled = false, onClick } = props;

  return (
    <ButtonBase
      disabled={disabled}
      sx={{
        textAlign: "left",
        opacity: disabled ? 0.5 : 1,
        alignSelf: "flex-start",
      }}
      onClick={onClick}
    >
      <Stack direction="row" spacing={4} alignItems="center">
        <CbhIcon type="calendar-clock" />
        <Text semibold variant="body2" sx={{ textDecoration: "underline" }}>
          Add to calendar
        </Text>
      </Stack>
    </ButtonBase>
  );
}
